import styled, { css } from 'styled-components';
import { marginStyles } from '../../styles/components.js';

// TODO min-width 240px on input and 400px on dropdown
const FilteredSearchInputGroup = styled.div `
  position: relative;
  width: 100%;

  ${props => marginStyles(props.margin)}
`;
const Dropdown = styled.ul `
  box-sizing: border-box;
  background: ${props => props.theme.colors.background.primary};
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15);
  border-radius: ${props => props.theme.borderRadii.large};
  padding: 16px 8px 8px;
  margin-top: 8px;
  position: absolute;
  left: 0px;
  width: 100%;
`;
const filterRowHover = css `
  background: ${props => props.theme.colors.background.accent2};

  p {
    color: ${props => props.theme.colors.content.primary};
  }
`;
const FilterRow = styled.li `
  background: ${props => props.theme.colors.background.primary};
  display: flex;
  align-items: center;
  padding: 8px;
  cursor: ${props => (props.disabled ? 'auto' : 'pointer')};
  border-radius: ${props => props.theme.borderRadii.small};

  ${props => (props.selected ? filterRowHover : '')}
  &:hover {
    ${props => (props.disabled ? '' : filterRowHover)}
  }
`;
const FilterTag = styled.div `
  background: ${props => props.theme.colors.background.secondary};
  border-radius: ${props => props.theme.borderRadii.small};
  box-sizing: border-box;
  border: 1px solid ${props => props.theme.colors.background.tertiary};
  color: ${props => props.theme.colors.content.primary};
  padding: 4px 8px;
  font-family: ${props => props.theme.fontFamilies.main.medium};
  font-size: ${props => props.theme.fontSizes[400]};
  line-height: ${props => props.theme.lineHeights.large};
  white-space: nowrap;
`;

export { Dropdown, FilterRow, FilterTag, FilteredSearchInputGroup };
